import { BorderRadius, Color, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const PaneWrapper = styled.div`
  display: flex;
  position: fixed;
  inset: 0;
  z-index: ${zIndex.SecondaryFullScreenPanel};
  background-color: ${transparentize(0.52, Color.Grey950)};

  .theme-layout-dark & {
    filter: invert(100%) hue-rotate(-180deg) saturate(2.5) contrast(0.75) brightness(1.2);
  }
`

// `transform` makes this the containing block for any `position: fixed` descendant —
// including a Drawer portaled in here via BankTransactionDrawer's `portalContainer` prop —
// so it renders confined to this card's box instead of the viewport. `overflow: hidden`
// then clips it to the card's rounded rectangle.
export const PaneCard = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: ${Spacing.S32};
  border-radius: ${BorderRadius.R16};
  transform: translateZ(0);
  background-color: ${Color.White};
  box-shadow: 0 10px 70px ${transparentize(0.8, Color.Black)};
  overflow: hidden;
`

// Padding lives here (below the banner, which stays flush with the card's edges) so it only
// affects the actual page content — filters, list, etc — not the banner itself.
export const PaneContent = styled.div`
  flex: 1;
  padding: ${Spacing.S24};
  overflow-y: auto;
`
